import {
  GET_PUBLIC_UNSUBSCRIBE_GROUPS_REQUEST,
  GET_PUBLIC_UNSUBSCRIBE_GROUPS_SUCCESS,
  GET_PUBLIC_UNSUBSCRIBE_GROUPS_FAILURE,
  GET_UNSUBSCRIBE_PREFERENCE_REQUEST,
  GET_UNSUBSCRIBE_PREFERENCE_SUCCESS,
  GET_UNSUBSCRIBE_PREFERENCE_FAILURE,
  CREATE_UNSUBSCRIBE_PREFERENCE_REQUEST,
  CREATE_UNSUBSCRIBE_PREFERENCE_SUCCESS,
  CREATE_UNSUBSCRIBE_PREFERENCE_FAILURE,
  UPDATE_UNSUBSCRIBE_PREFERENCE_REQUEST,
  UPDATE_UNSUBSCRIBE_PREFERENCE_SUCCESS,
  UPDATE_UNSUBSCRIBE_PREFERENCE_FAILURE,
  CLEAR_UNSUBSCRIBE_PREFERENCES,
  CLEAR_UNSUBSCRIBE_PREFERENCE_STATUS,
  GetPublicUnsubscribeGroupsRequestAction,
  GetPublicUnsubscribeGroupsSuccessAction,
  GetPublicUnsubscribeGroupsFailureAction,
  GetUnsubscribePreferenceRequestAction,
  GetUnsubscribePreferenceSuccessAction,
  GetUnsubscribePreferenceFailureAction,
  CreateUnsubscribePreferenceRequestAction,
  CreateUnsubscribePreferenceSuccessAction,
  CreateUnsubscribePreferenceFailureAction,
  UpdateUnsubscribePreferenceRequestAction,
  UpdateUnsubscribePreferenceSuccessAction,
  UpdateUnsubscribePreferenceFailureAction,
  ClearUnsubscribePreferencesAction,
  ClearUnsubscribePreferenceStatusAction,
} from './unsubscribePreference.types';
import { IUnsubscribeGroup } from '../../types/unsubscribeGroups/unsubscribeGroups.types';
import {
  CreateUnsubscribePreferencePayload,
  UpdateUnsubscribePreferencePayload,
} from '../../services/unsubscribePreferenceService/unsubscribePreferenceService';

export const getPublicUnsubscribeGroupsRequest = (
  trackingId: string
): GetPublicUnsubscribeGroupsRequestAction => ({
  type: GET_PUBLIC_UNSUBSCRIBE_GROUPS_REQUEST,
  payload: {
    trackingId,
  },
});

export const getPublicUnsubscribeGroupsSuccess = (
  unsubscribeGroups: IUnsubscribeGroup[]
): GetPublicUnsubscribeGroupsSuccessAction => ({
  type: GET_PUBLIC_UNSUBSCRIBE_GROUPS_SUCCESS,
  payload: unsubscribeGroups,
});

export const getPublicUnsubscribeGroupsFailure = (
  error: string
): GetPublicUnsubscribeGroupsFailureAction => ({
  type: GET_PUBLIC_UNSUBSCRIBE_GROUPS_FAILURE,
  payload: {
    error,
  },
});

export const getUnsubscribePreferenceRequest = (
  trackingId: string
): GetUnsubscribePreferenceRequestAction => ({
  type: GET_UNSUBSCRIBE_PREFERENCE_REQUEST,
  payload: {
    trackingId,
  },
});

export const getUnsubscribePreferenceSuccess = (
  response: any
): GetUnsubscribePreferenceSuccessAction => ({
  type: GET_UNSUBSCRIBE_PREFERENCE_SUCCESS,
  payload: response,
});

export const getUnsubscribePreferenceFailure = (
  error: string
): GetUnsubscribePreferenceFailureAction => ({
  type: GET_UNSUBSCRIBE_PREFERENCE_FAILURE,
  payload: {
    error,
  },
});

export const createUnsubscribePreferenceRequest = (
  trackingId: string,
  data: CreateUnsubscribePreferencePayload
): CreateUnsubscribePreferenceRequestAction => ({
  type: CREATE_UNSUBSCRIBE_PREFERENCE_REQUEST,
  payload: {
    trackingId,
    data,
  },
});

export const createUnsubscribePreferenceSuccess = (
  response: any
): CreateUnsubscribePreferenceSuccessAction => ({
  type: CREATE_UNSUBSCRIBE_PREFERENCE_SUCCESS,
  payload: response,
});

export const createUnsubscribePreferenceFailure = (
  error: string
): CreateUnsubscribePreferenceFailureAction => ({
  type: CREATE_UNSUBSCRIBE_PREFERENCE_FAILURE,
  payload: {
    error,
  },
});

export const updateUnsubscribePreferenceRequest = (
  trackingId: string,
  data: UpdateUnsubscribePreferencePayload
): UpdateUnsubscribePreferenceRequestAction => ({
  type: UPDATE_UNSUBSCRIBE_PREFERENCE_REQUEST,
  payload: {
    trackingId,
    data,
  },
});

export const updateUnsubscribePreferenceSuccess = (
  response: any
): UpdateUnsubscribePreferenceSuccessAction => ({
  type: UPDATE_UNSUBSCRIBE_PREFERENCE_SUCCESS,
  payload: response,
});

export const updateUnsubscribePreferenceFailure = (
  error: string
): UpdateUnsubscribePreferenceFailureAction => ({
  type: UPDATE_UNSUBSCRIBE_PREFERENCE_FAILURE,
  payload: {
    error,
  },
});

export const clearUnsubscribePreferences =
  (): ClearUnsubscribePreferencesAction => ({
    type: CLEAR_UNSUBSCRIBE_PREFERENCES,
  });

export const clearUnsubscribePreferenceStatus =
  (): ClearUnsubscribePreferenceStatusAction => ({
    type: CLEAR_UNSUBSCRIBE_PREFERENCE_STATUS,
  });
